import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import shopErrors from '~/services/shop/errors';
import { getUrl } from '~/services/shop/utils';

export default async function deleteBasketVoucher(
    basketReference: string | undefined,
    couponCode: string,
) {
    if (!basketReference) {
        return Promise.reject(new Error(shopErrors.referenceNotFound.message));
    }

    try {
        const voucherReturn = await shop
            .delete(getUrl(`/baskets/${basketReference}/voucher/${couponCode}`), {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .json<ShopTypes.BasketResponse>();

        return voucherReturn;
    } catch (error) {
        console.error('Error deleting basket voucher:', error);
        throw error;
    }
}
